<template>
  <div class="col order-history pb-4">
    <h5
      id="user-order-head"
      class="myorders"
						data-test="ordersHeading"
    >
      My Orders
    </h5>
			<page-loader v-if="showLoader">
			</page-loader>
			<div v-else>
    <router-link
					:to="{
					path: '/user/order/orderedProducts',
					query: {
							display_text: 'My Orders'
						}
					}"
      tag="button"
      class="btn btn-link btn-orders-tab"
      :class="($route.path === '/user/order/orderedProducts')?'active':''"
						data-test="ordersProductsLink"
						id="ordersProductsLink"
					style="cursor: pointer"
    >
      Products
    </router-link>
    <router-link
					:to="{
					path: '/user/order/orderedGiftCards',
					query: {
							display_text: 'My Orders'
						}
					}"
      tag="button"
      class="btn btn-link btn-orders-tab"
      :class="($route.path === '/user/order/orderedGiftCards')?'active':''"
						data-test="ordersGiftsLink"
						id="ordersGiftsLink"
					style="cursor: pointer"
    >
      Gift Cards
    </router-link>
    <hr>
    <!--<loading-->
      <!--class="lodderz"-->
      <!--:active.sync="showLoader"-->
      <!--:can-cancel="false"-->
      <!--:is-full-page="false"-->
      <!--:opacity=1-->
      <!--loader="dots"-->
      <!--z-index="-1"-->
    <!--&gt;-->
    <!--</loading>-->
    <!--<div-->
    <!--class="row p-4 card"-->
    <!--v-for="(order,key) in orders"-->
    <!--:key="key"-->
    <!--v-if="(orders && orders.length > 0)"-->
    <!--&gt;-->
    <!--<h5 :id="'user-order-no-'+key">-->
    <!--Order No:-->
    <!--<a href=""-->
    <!--@click.prevent="orderTracking(order.order_number)"-->
    <!--:id="'user-order-no-link-'+key"-->
    <!--&gt;-->
    <!--{{(order.order_number+'').toUpperCase()}}-->
    <!--</a>-->
    <!--</h5>-->
    <!--<div v-for="product in order.orderProductDetails"-->
    <!--:key="product.product_id+'_'+product.order_detail_id"-->
    <!--class="col-12 row pb-3"-->
    <!--&gt;-->
    <!--<div class="col-4 col-md-2">-->
    <!--<img-->
    <!--class="fluid-img"-->
    <!--style="width: 75px; height: 75px;object-fit: contain;"-->
    <!--:src="product.product_image"-->
    <!--alt=""-->
    <!--srcset=""-->
    <!--:id="'user-pdtorder-img-'+key+product.product_id">-->
    <!--</div>-->
    <!--<div class="col-8 col-md-3">-->
    <!--<router-link-->
    <!--:to="{-->
    <!--path: '/product_description',-->
    <!--query: {-->
    <!--productName: product.product_name,-->
    <!--productId: product.product_id }}"-->
    <!--:id="'user-pdtorder-name-link-'+key+product.product_id"-->
    <!--&gt;-->
    <!--{{product.product_name}}-->
    <!--</router-link>-->
    <!--<span class="d-none d-md-block"-->
    <!--:id="'user-pdtorder-qnty-no-link-'+key+product.product_id"-->
    <!--style="font-size: 0.75rem"-->
    <!--&gt;-->
    <!--Quantity: {{product.quantity}}-->
    <!--</span>-->
    <!--<span class="d-none d-md-block"-->
    <!--:id="'user-pdtorder-unitprice-no-link-'+key+product.product_id"-->
    <!--style="font-size: 0.75rem"-->
    <!--&gt;-->
    <!--Unit Price: {{product.price | currencyConversion}}-->
    <!--</span>-->

    <!--</div>-->
    <!--<div class="col-4 p-3 col-md-3">-->
    <!--<p :id="'user-pdtorder-price-'+key+product.product_id"-->
    <!--style="white-space: nowrap;font-size: 0.75rem;"-->
    <!--&gt;-->
    <!--{{product.sub_total | currencyConversion}}-->
    <!--</p>-->
    <!--</div>-->
    <!--<div class="col-8 p-3 col-md"-->
    <!--:id="'user-pdtorder-date-'+key+product.product_id"-->
    <!--style="font-size: 0.75rem"-->
    <!--&gt;-->
    <!--{{new Date(product.order_date).toLocaleDateString()}}-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <router-view>
    </router-view>
			</div>
  </div>
</template>

<script>
// import Loading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'
import { orderApi } from '@/services/ApiServices/orderApi'
import PageLoader from '../../../shared/loader/pageLoader'

export default {
	// components: {
	// 	Loading
	// },
	components: { PageLoader },
	computed: {
		...mapGetters('order', ['getTotalOrderData'])
	},
	beforeMount () {
		orderApi.getOrders()
			.then((res) => {
				// if (res.body) {
				//   this.orders = JSON.parse(JSON.stringify(res.body.orderHistory));
				//
				//   this.orderLength = this.orders.length;
				// if (res.body.orderHistory.length) {
				//   this.showLoader = false;
				//   this.$toasted.show('You have no orders yet..');
				// } else {
				//   this.orderLength = this.orders.length;
				//   this.showLoader = false;
				// }
				// } else {
				//   this.orders = [];
				//   this.orderLength = this.orders.length;
				// }
				this.showLoader = false
			}).catch((e) => {
				this.showLoader = false
				// this.$toasted.show('You have no orders yet..');
			})
	},
	mounted () {
	},
	data () {
		return {
			// orders: [],
			// orderLength: 0,
			showLoader: true
			// showGiftFields: false,
		}
	}
	// methods: {
	//   orderTracking(ordNum) {
	//     this.$router.push({
	//       path: '/user/orders/orderTracking',
	//       query: { orderNumber: ordNum },
	//     });
	//   },
	// },
}
</script>
